import { render, staticRenderFns } from "./c-cascader-category.vue?vue&type=template&id=78fedf1a&scoped=true"
import script from "./c-cascader-category.vue?vue&type=script&lang=js"
export * from "./c-cascader-category.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fedf1a",
  null
  
)

export default component.exports